import styled from '@emotion/styled';
import {
  SubNavigationNavLink,
  SubNavigationNavBar,
} from 'components/Navigation/SubNavigation';
import css from '@emotion/css';
import { shadowOverlay } from '__app/colors';
import { breakpoints, layers } from '__app/spacing';
import FullscreenModal from '__components/Modals/Fullscreen';

export const HeaderContainer = styled.div<{ scrolledTop: boolean }>`
  background-color: ${({ scrolledTop }) =>
    scrolledTop
      ? 'var(--color-background-default)'
      : 'var(--color-background-white)'} !important;
  display: flex;
`;

export const ChildHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  overflow: hidden;
`;

export const ChildCenterHeaderContainer = styled(ChildHeaderContainer)`
  flex: 1;
  padding-left: 18px;
  padding-right: 8px;
`;

export const StyledFullscreenModal = styled(FullscreenModal)`
  min-width: ${breakpoints.lg}px;
  .modal-content {
    background-color: ${({ scrolledTop }) =>
      scrolledTop
        ? 'var(--color-background-default)'
        : 'var(--color-background-white)'};
    & > div:first-of-type {
      margin: 0;
      padding: 0 20px;
      @media (max-width: ${breakpoints.md}px) {
        margin: 0;
        padding: 0 15px;
      }
      z-index: ${layers.modals(1, 6)};
      height: 96px;
      background-color: ${({ scrolledTop }) =>
        scrolledTop
          ? 'var(--color-background-default)'
          : css`
              var(--color-background-white);
              ${shadowOverlay}
            `};
    }
    & > div:last-of-type {
      background-color: var(--color-background-default);
      overflow-y: auto;
    }
  }

  @media screen and (max-width: ${breakpoints.lg}px) {
    min-width: 0;
  }
`;

export const StyledSubNavigationNavBar = styled(SubNavigationNavBar)`
  & > .navbar {
    margin-bottom: 20px;
  }
`;

export const StyledSubNavigationNavLink = styled(SubNavigationNavLink)<{
  disabled?: boolean;
}>`
  ${({ disabled }) =>
    disabled &&
    css`
      & > i,
      & > span {
        color: var(--color-font-placeholder);
      }
      background-color: var(--color-background-light);
    `}
`;
